import { createSelector } from "reselect";
import { PresetsState } from "../../types";
import { getPresetById, getPresetsForSpace, getTempPreset } from "./presets";

export const getCurrentPresetEntity = createSelector(
    getPresetsForSpace,
    (state: DeepPartial<PresetsState>) => state.preset.currentPresetId,
    getTempPreset,
    (presets, currentPresetId, tempPreset) => {
        if (currentPresetId && tempPreset?.Id === currentPresetId) {
            // make sure that the base preset belongs to the current space
            const basePreset = getPresetById(presets, tempPreset.BasePresetId);
            return basePreset ? tempPreset : null;
        }

        return getPresetById(presets, currentPresetId);
    }
);

export const getCurrentPresetId = createSelector(getCurrentPresetEntity, preset => preset?.Id);
